import React from 'react';
import { func, number } from 'prop-types';

import { Row, Col, Input, Typography } from '@ajaibid/components';

import { useStockBuySellContext, useValidateForm } from '../../../hooks';

const InputLotCount = (props) => {
  const { marginTop, marginBottom, onSubmit } = props;

  const { code, formState, formKey, formAction, dispatch, isAmend, isSell, maxSell } =
    useStockBuySellContext();
  const { isFormValidated } = useValidateForm();

  const onEnter = () => {
    if (isFormValidated) {
      onSubmit();
    }
  };

  const isAmendIncreaseLot =
    isAmend && formState[formKey.INPUT_LOT_COUNT] > formState[formKey.CONST_MAX_LOT_AMEND];

  const getInputError = () => {
    switch (true) {
      case isAmendIncreaseLot:
        return 'Tidak dapat menambah jumlah lot';
      default:
        return '';
    }
  };

  const inputValue = formState?.[formKey.INPUT_LOT_COUNT] ?? '';

  return (
    <Row noGutters marginTop={marginTop} marginBottom={marginBottom}>
      <Col size={3}>
        <Typography type="body" bold margin={0}>
          Lot
        </Typography>
      </Col>
      <Col size={9}>
        <Input.Number
          id={formKey.INPUT_LOT_COUNT}
          name={formKey.INPUT_LOT_COUNT}
          block
          size="sm"
          thousandSeparator={false}
          value={inputValue}
          maxValue={isSell ? maxSell.value : null}
          onChange={(e) =>
            dispatch({ type: formAction.CHANGE_LOT_COUNT, code, payload: e.target.value })
          }
          onEnter={onEnter}
          error={getInputError()}
        />
      </Col>
    </Row>
  );
};

InputLotCount.propTypes = {
  marginTop: number,
  marginBottom: number,
  onSubmit: func,
};

InputLotCount.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
  onSubmit: () => {},
};

export default InputLotCount;
